/**********************************************************************
 * src/components/Dashboard/Rubrica/RubricaOverlay.jsx
 *********************************************************************/
import React, { useState, useEffect } from 'react'
import api from '../../../services/api'
import '../../../css/rubricaOverlay.css'

const RubricaOverlay = ({ item, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    name: '',
    notes: '',
  })

  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  useEffect(() => {
    if (item) {
      setFormData({
        name: item.name || '',
        notes: item.notes || '',
      })
    }
  }, [item])

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }))

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess('')

    if (!formData.name.trim()) {
      setError('Il titolo è obbligatorio')
      return
    }

    try {
      await api.put(`/rubrica/${item.id}`, formData, {
        headers: { 'Content-Type': 'application/json' },
      })

      setSuccess('Rubrica aggiornata con successo!')
      onUpdate?.()
      setTimeout(onClose, 1500)
    } catch (err) {
      console.error("Errore nell'aggiornamento della rubrica:", err)
      setError("Errore nell'aggiornamento della rubrica")
    }
  }

  return (
    <div className="rubrica-overlay-container" onClick={onClose}>
      <div className="rubrica-overlay-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <h2>Modifica Rubrica</h2>

        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}

        <div className="rubrica-overlay-body">
          <form onSubmit={handleSubmit}>
            <label>
              Titolo: <span className="required">*</span>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Descrizione:
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                placeholder="Descrizione (opzionale)"
              />
            </label>

            <button type="submit">Salva Modifiche</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default RubricaOverlay
